<div #dropdownWrapper class="dropdown w-100 position-relative">
  <div class="input-group">
    <input #searchInput
      type="text"
      class="form-control autocomplete-input"
      [(ngModel)]="searchText"
      (input)="onSearchChange()"
      placeholder="Select Caremember"
      [disabled]="isDropdownDisabled" />
      <!-- Clear (X) button -->
      @if (searchText && searchText !== 'Any') {
        <button type="button"
          class="input-group-text cursor-pointer"
          (click)="clearSelection()"
          aria-label="Clear care member selection">
          ✕
        </button>
      }

      <button type="button" class="input-group-text dropdown-toggle"
        (click)="focusInput()"
        [class.disabled]="isDropdownDisabled"
        [disabled]="isDropdownDisabled"
        aria-label="Open care member list"></button>
    </div>

    <!-- Dropdown -->
    @if (dropdownOpen && filteredStates.length) {
      <div
        class="dropdown-menu show w-100 mt-0 shadow-sm"
        style="max-height: 250px; overflow-y: auto;">
        <!-- Default "Any" option -->
        <button type="button"
          class="dropdown-item"
          (click)="selectState(null)">
          Any
        </button>
        @for (staff of filteredStates; track staff) {
          <button
            type="button"
            class="dropdown-item"
            (click)="selectState(staff)">
            {{ staff.name }} - {{ staff.emailId }}
          </button>
        }
      </div>
    }
  </div>
